import { verificationService } from "services/verfication.service";
import { verificationConstants } from "./actionTypes";

export const verificationActions = {
  verify,
  verifyEmailChange,
  confirmEmailChange,
};

export function verifyEmailChange(token) {
  return (dispatch) => {
    dispatch(request(token));

    verificationService.verifyEmailChange(token).then(
      (response) => {
        dispatch(success(response.message));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request(token) {
    return { type: verificationConstants.VERIFY_EMAIL_CHANGE_REQUEST, token };
  }
  function success(message) {
    return {
      type: verificationConstants.VERIFY_EMAIL_CHANGE_SUCCESS,
      message,
    };
  }
  function failure(error) {
    return { type: verificationConstants.VERIFY_EMAIL_CHANGE_FAILURE, error };
  }
}

export function confirmEmailChange(token) {
  return (dispatch) => {
    dispatch(request(token));

    verificationService.confirmEmailChange(token).then(
      (response) => {
        dispatch(success(response.message));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request(token) {
    return { type: verificationConstants.CONFIRM_EMAIL_CHANGE_REQUEST, token };
  }
  function success(message) {
    return {
      type: verificationConstants.CONFIRM_EMAIL_CHANGE_SUCCESS,
      message,
    };
  }
  function failure(error) {
    return { type: verificationConstants.CONFIRM_EMAIL_CHANGE_FAILURE, error };
  }
}

export function verify(token) {
  return (dispatch) => {
    dispatch(request(token));

    verificationService.verify(token).then(
      (user) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request(token) {
    return { type: verificationConstants.CHECK_USER_REQUEST, token };
  }
  function success(message) {
    return { type: verificationConstants.CHECK_USER_SUCCESS, message };
  }
  function failure(error) {
    return { type: verificationConstants.CHECK_USER_FAILURE, error };
  }
}
